<img *ngIf="!colored && !scrolled" src="../../../assets/images/logos/logo-white.png" alt="logo">
<img *ngIf="scrolled && !colored || opened" [ngClass]="{'smaller': scrolled && !opened }" src="../../../assets/images/logos/logo-black.png" alt="logo">
